import { BezierDefinition, Variants } from 'framer-motion';

const duration = 0.45;
const ease: BezierDefinition = [0.44, 0, 0.56, 1];

export const pageSlideVariants: Variants = {
  initial: ({ direction }: { direction: 'up' | 'down' }) => ({
    y: direction === 'down' ? '-20%' : '20%',
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  }),
  in: {
    y: 0,
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  },
  out: ({ direction }: { direction: 'up' | 'down' }) => ({
    y: direction === 'down' ? '20%' : '-20%',
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  }),
};

export const pageSlideHorizontalVariants: Variants = {
  initial: ({ direction }: { direction: 'forward' | 'back' }) => ({
    x: direction === 'forward' ? '-100%' : '100%',
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  }),
  in: {
    x: 0,
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  },
  out: () => ({
    x: 0,
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  }),
};

export const opacityVariants: Variants = {
  initial: () => ({
    opacity: 0,
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  }),
  in: {
    opacity: 1,
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  },
  out: () => ({
    opacity: 0,
    transition: {
      duration,
      delay: 0,
      ease,
      delayChildren: 0,
    },
  }),
};
